import BankIcon from "assets/icon/BankIcon";
import ChevronRightIcon from "assets/icon/ChevronRightIcon";
import PinLocationIcon from "assets/icon/PinLocationIcon";
import UserIcon from "assets/icon/UserIcon";
import UserXIcon from "assets/icon/UserXIcon";
import { useNavigate } from "react-router-dom";

export default function Setting(){
    let navigate = useNavigate()

    return(
        <div className="flex flex-col gap-2">
            <div >
                <span className="font-semibold text-2xl">Setting</span>
            </div>
            <hr />
            <div>
                {/* <button className="px-4 py-4  w-full text-left flex justify-between hover" onClick={() => {navigate("/setting/system-setting")}}>
                    <span className="">System Setting</span>
                    <ChevronRightIcon className="fill-black w-6" />
                </button>
                <hr /> */}

                <div className="border rounded-md p-4 bg-white">
                    <hr />
                    <button className="px-4 py-4  w-full text-left flex justify-between hover" onClick={() => {navigate("/setting/bank")}}>
                        <div className="flex items-center gap-4">
                            <div className="w-6 flex justify-center">
                                <BankIcon />
                            </div>
                            <span className="">Bank</span>
                        </div>
                        <ChevronRightIcon className="fill-black w-6" />
                    </button>
                    <hr />
                    <button className="px-4 py-4  w-full text-left flex justify-between hover" onClick={() => {navigate("/setting/edc")}}>
                        <div className="flex items-center gap-4">
                            <div className="w-6 flex justify-center">
                                <BankIcon />
                            </div>
                            <span className="">Mesin EDC</span>
                        </div>
                        <ChevronRightIcon className="fill-black w-6" />
                    </button>
                    <hr />
                    <button className="px-4 py-4  w-full text-left flex justify-between hover" onClick={() => {navigate("/setting/card-vendor")}}>
                        <div className="flex items-center gap-4">
                            <div className="w-6 flex justify-center">
                                <BankIcon />
                            </div>
                            <span className="">Card Vendor</span>
                        </div>
                        <ChevronRightIcon className="fill-black w-6" />
                    </button>
                    <hr />
                    <button className="px-4 py-4  w-full text-left flex justify-between hover" onClick={() => {navigate("/setting/transfer-source")}}>
                        <div className="flex items-center gap-4">
                            <div className="w-6 flex justify-center">
                                <BankIcon />
                            </div>
                            <span className="">Transfer Source</span>
                        </div>
                        <ChevronRightIcon className="fill-black w-6" />
                    </button>
                    <hr />
                </div>
                
                <div className={`border rounded-md bg-white p-4 mt-5 ${localStorage.getItem("IsAdmin") === "1" ? "" : "hidden"}`}>
                    <hr />
                    <button className="px-4 py-4  w-full text-left flex justify-between hover" onClick={() => {navigate("/setting/reseller")}}>
                        <div className="flex items-center gap-4">
                            <div className="w-6 flex justify-center">
                                <UserIcon className="fill-black" />
                            </div>
                            <span className="">Reseller</span>
                        </div>
                        <ChevronRightIcon className="fill-black w-6" />
                    </button>
                    <hr />
                    <button className="px-4 py-4  w-full text-left flex justify-between hover" onClick={() => {navigate("/setting/customer-exeption")}}>
                        <div className="flex items-center gap-4">
                            <div className="w-6 flex justify-center">
                                <UserXIcon className="fill-black w-6" />
                            </div>
                            <span className="">Customer Exeption</span>
                        </div>
                        <ChevronRightIcon className="fill-black w-6" />
                    </button>
                    <hr />
                </div>

                <div className={`border rounded-md bg-white p-4 mt-5 ${localStorage.getItem("IsAdmin") === "1" ? "" : "hidden"}`}>
                    <hr />
                    <button className="px-4 py-4  w-full text-left flex justify-between hover" onClick={() => {navigate("/setting/location")}}>
                        <div className="flex items-center gap-4">
                            <div className="w-6 flex justify-center">
                                <PinLocationIcon className="fill-black" />
                            </div>
                            <span className="">Location Setting</span>
                        </div>
                        <ChevronRightIcon className="fill-black w-6" />
                    </button>
                    <hr />
                    <button className="px-4 py-4  w-full text-left flex justify-between hover" onClick={() => {navigate("/setting/user")}}>
                        <div className="flex items-center gap-4">
                            <div className="w-6 flex justify-center">
                                <UserIcon className="fill-black" />
                            </div>
                            <span className="">User Setting</span>
                        </div>
                        <ChevronRightIcon className="fill-black w-6" />
                    </button>
                    <hr />
                </div>
                
            </div>
        </div>
    )
}